<!-- tab头 -->
<template>
  <div :style="listStyle" class="header-box">
    <div
      v-for="(item, index) in list" :key="index"
      :style="itemStyle"
      @click="click(index)"
      class="tab-item">
      <div :class="curIndex === index ? 'cur-tab-name': 'tab-name'"
        :style="curIndex === index ? curItemStyle : {} ">{{item.tabName}}</div>
      <div :class="curIndex === index ? 'cur-tab' : 'normal-tab'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab-list-header',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    curIndex: {
      type: Number,
      default: 0,
    },
    listStyle: {
      type: Object,
      default: () => ({}),
    },
    itemStyle: {
      type: Object,
      default: () => ({}),
    },
    curItemStyle: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    click(index) {
      this.$emit('clickTab', index);
    },
  },
};
</script>

<style lang="less" scoped>
.header-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.tab-item {
  height: 62px;
  // flex: 1;
  font-size: 32px;
  line-height: 32px;
  color: #333333;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tab-name {
  margin-top: 8px;
  font-weight: 400;
}
.cur-tab-name {
  margin-top: 8px;
  font-weight: 700;
}
.cur-tab {
  width: 30px;
  height: 6px;
  margin-top: 10px;
  background-color: #FF4400;
  border-radius: 3px;
  opacity: 1;
}
.normal-tab {
  width: 30px;
  height: 6px;
  margin-top: 10px;
  background-color: #ffffff;
  border-radius: 3px;
  opacity: 0;
}
</style>
